import { Box, Select, Option, Typography } from "@mui/joy";
import { useEffect, useState } from "react";
import { Shield } from "lucide-react";

interface IGutterGuardType {
    value: string | null;
    onChange: (value: string) => void;
    loading?: boolean;
}

export function GutterGuardType(props: IGutterGuardType) {
    const { value, onChange, loading } = { ...props };
    const [guardType, setGuardType] = useState<string | null>(null);

    const handleUpdate = (event: any, newValue: string | null) => {
        if (loading) return;
        const selectedValue = newValue || "";
        setGuardType(selectedValue);
        onChange(selectedValue);
    };

    useEffect(() => {
        if (value) {
            setGuardType(value);
        }
    }, [value]);

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md", mb: 0.5 }}>
                Gutter Guard Type
            </Typography>

            <Select
                placeholder="Select gutter guard type"
                value={guardType}
                onChange={handleUpdate}
                disabled={loading}
                startDecorator={<Shield size={16} />}
                slotProps={{ listbox: { sx: { zIndex: 10001 } } }}
            >
                <Option value="None">None</Option>
                <Option value="Standard">Standard</Option>
                <Option value="High Grade">High Grade</Option>
            </Select>
        </Box>
    );
}
